export default class UpdatePersonalPromovido {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPersonal, idConvocatoriaPersonal, payload) {
    try {
      const result = await this.#repository.updatePersonalConvocatoria(idPersonal, idConvocatoriaPersonal, payload)
      return result
    } catch (error) {
      console.error('Error al actualizar el personal promovido:', error)
      throw error
    }
  }
}
